import {Schedule} from "@/entity/Schedule";
import {Col, Form, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import style from './schedule.scss';
import globalStyle from '@/styles/Global.scss';
import {isSaturday, isSunday} from "@/util/date";
import {isHoliday} from "@holiday-jp/holiday_jp";
import {addSchedule, updateSchedule} from "@/api/schedule";
import {Date} from "@/components/atom/Date";

const ScheduleEditor = ({schedule, onDidSave = () => {}}) => {
  const [scheduleInEdit, setScheduleInEdit] = useState(schedule)

  useEffect(() => {
    (async () => {
      if (!schedule) {
        return
      }
      setScheduleInEdit(new Schedule({...schedule}))
    })()
  }, [schedule])

  const onSave = async () => {
    if (!schedule.id) {
      await addSchedule({schedule: scheduleInEdit})
    } else {
      await updateSchedule({ id: schedule.id, schedule: scheduleInEdit })
    }
    onDidSave()
  }

  return <>
    <div className={`${style.container}
      ${ isSaturday({date: schedule.getDate()}) && style.saturdayColumn }
      ${ (isSunday({date: schedule.getDate()}) || isHoliday(schedule.getDate())) && style.sundayColumn }
      `}>
      <Row>
        <Col className={style.date} xs={12}>
          <Date date={scheduleInEdit.getDate()} />
          {
            !schedule.isEqual(scheduleInEdit) && <>
              <span className={globalStyle.link} onClick={onSave}>保存</span>
            </>
          }
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Form.Select className={style.holidaySelect} value={`${scheduleInEdit.holiday}`} aria-label="営業日" onChange={(e) => {
            setScheduleInEdit(new Schedule({...scheduleInEdit, holiday: e.target.value}))
          }}>
            <option value={'false'}>営業日</option>
            <option value={'true'}>休業日</option>
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Form.Control type="text" value={scheduleInEdit.businessHour} onChange={(e) => {
            setScheduleInEdit(new Schedule({...scheduleInEdit, businessHour: e.target.value}))
          }} placeholder="営業時間" />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Form.Control as="textarea" style={{color: scheduleInEdit.holiday ? 'rgb(42, 167, 56)' : 'black'}} value={scheduleInEdit.memo} onChange={(e) => {
            setScheduleInEdit(new Schedule({...scheduleInEdit, memo: e.target.value}))
          }} placeholder="メモ" />
        </Col>
      </Row>
      <hr className={globalStyle.separator} />
    </div>
  </>
}

export default ScheduleEditor;
